var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313358",
    d: "m7.5 0 2.55 4.295L15 5.348l-3.375 3.706.51 4.946L7.5 11.995 2.865 14l.51-4.946L0 5.348l4.95-1.053z"
  })));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTAwMjQgMEwxMC4wNDk2IDQuMjk1NDZMMTUuMDAwMiA1LjM0NzUyTDExLjYyNTIgOS4wNTQzM0wxMi4xMzU1IDE0TDcuNTAwMjQgMTEuOTk1NUwyLjg2NDk5IDE0TDMuMzc1MjQgOS4wNTQzM0wwLjAwMDI0NDE0MSA1LjM0NzUyTDQuOTUwODUgNC4yOTU0Nkw3LjUwMDI0IDBaIiBmaWxsPSIjMzEzMzU4Ii8+Cjwvc3ZnPgo=";